<div class="card-head">
  <h2>Order tracking</h2>
  <div class="flex-fill"></div>
  @if (orderTracking.history && orderTracking.history.length > 0) {
    <button class="linkish" (click)="toggleHistory()"
            [attr.aria-expanded]="historyOpen"
            data-test="tx-detail-order-history-toggle">
      {{ historyOpen ? 'Hide history' : 'Show history' }}
    </button>
  }
</div>

<div class="card-body">
  @if (orderTracking.currentStatus) {
    <div class="order-now">
      <span class="order-status-chip" data-test="tx-detail-order-status-chip">
        <span class="dot"></span>{{ orderTracking.currentStatus }}
      </span>

      <select class="order-select" (change)="onStatusChange($event)" [disabled]="updating"
              aria-label="Change order status" data-test="tx-detail-order-status-select">
        <option value="" selected disabled>Change status…</option>
        @for (status of selectableStatuses; track status) {
          <option [value]="status">{{ status }}</option>
        }
      </select>

      @if (orderTracking.updatedOn) {
        <span class="order-updated">
          Updated <span class="upper-time">{{ orderTracking.updatedOn | date: 'dd/MM/yy h:mm a' }}</span>
          @if (orderTracking.updatedBy) { <span>by {{ orderTracking.updatedBy }}</span> }
        </span>
      }
    </div>
  } @else {
    <div class="order-empty">
      <span class="text-muted">No order status set.</span>
      <select class="order-select" (change)="onStatusChange($event)" [disabled]="updating"
              aria-label="Set order status" data-test="tx-detail-order-status-select">
        <option value="" selected disabled>Set a status…</option>
        @for (status of orderTracking.availableStatuses; track status) {
          <option [value]="status">{{ status }}</option>
        }
      </select>
    </div>
  }

  @if (historyOpen) {
    <div class="order-history" data-test="tx-detail-order-history">
      @for (entry of orderTracking.history; track entry.timestamp) {
        <div class="oh-row">
          <span class="oh-when upper-time">{{ entry.timestamp | date: 'dd/MM/yy h:mm a' }}</span>
          <span class="oh-status">{{ entry.status }}</span>
          @if (entry.setBy) { <span class="oh-by">· {{ entry.setBy }}</span> }
        </div>
      }
    </div>
  }
</div>
